/* RESPONSIBLE TEAM: team-data-foundations */
import AppstoreIndexController from 'embercom/controllers/base/appstore/index';

export default AppstoreIndexController;
